export class ConnectGitRepositoryInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "integrationId",
            "baseName": "integrationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerRepositoryId",
            "baseName": "providerRepositoryId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectGitRepositoryInput.attributeTypeMap;
    }
    constructor() {
    }
}
